var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 36,
    viewBox: "0 0 42 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3653 1.51129C2.3653 4.70092 1.87305 7.79601 1.87305 10.9871C1.87305 16.0097 1.9623 21.2762 3.47285 26.11C4.29152 28.7298 6.34963 31.2329 8.65513 32.646C10.7183 33.9105 13.3989 33.9997 15.7654 33.9997C17.9147 33.9997 20.2228 33.6656 21.563 31.7299C22.7162 30.0641 23.8137 28.484 24.5712 26.5613C25.131 25.14 25.2955 23.7617 25.7471 22.3224C27.8311 15.6797 28.4544 8.92802 28.4544 2.00354",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4492 30.7864C20.2886 31.5681 21.3695 31.9805 22.4128 32.4662C23.0863 32.7797 23.7615 33.1289 24.4744 33.366C25.0801 33.5675 25.7905 33.96 26.4143 34.0326C27.9611 34.2126 29.5059 34.2216 31.0314 33.9059C32.5196 33.598 34.0437 33.0248 35.4266 32.4395C38.1199 31.2996 39.5498 28.2867 39.5498 25.6206C39.5498 24.0664 39.3094 22.5193 38.1325 21.308C37.1041 20.2497 36.1498 19.537 34.7251 18.9684C32.9169 18.2468 31.0685 17.7337 29.1702 17.2287C28.0958 16.9428 27.1277 16.5871 26.1065 16.2022C25.3113 15.9025 24.705 15.4263 23.959 15.069C22.5689 14.4034 21.1923 13.2438 20.6089 11.8696C19.7985 9.9609 19.5029 7.57095 20.7449 5.76392C23.1673 2.23938 28.212 1.51129 32.3628 1.51129C34.2023 1.51129 36.8982 2.07416 39.1497 3.76277",
    stroke: "#FF630B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.9c4f5235ac8d9ec4f934e80ed2f453d9.svg";
export { ForwardRef as ReactComponent };